import { defineComponent as _defineComponent } from 'vue'
import LotAssignmentModal from "@/components/ui/modals/LotAssignmentModal.vue";
  import store from "@/store";
  
  import { getFirstLastName } from "@/helpers/user";
  import { getLotPreviousStatus } from "@/helpers/status";
  import { LotStatus } from "@/enums/LotStatus";
  import { LotConfirmModalActions } from "@/enums/LotConfirmModalActions";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotDetailsConfirmModal',
  props: {
    lot: {
      type: Object,
      required: true,
    },
    showModal: {
      type: String,
      required: true,
    },
  },
  emits: [
    "close",
    "confirm",
    "loading",
    "showCancelContractModal",
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function confirm() {
    const {
      CANCEL_CONTRACT,
      CANCEL_OFFLINE,
      CANCEL_OPTION,
      RETURN_PREVIOUS_STATUS,
      UNRELEASE,
      MARK_SETTLED,
    } = LotConfirmModalActions;

    close();
    emits("loading");

    if (props.showModal === CANCEL_OPTION) {
      cancelOption();
    } else if (props.showModal === UNRELEASE) {
      unrelease();
    } else if (props.showModal === CANCEL_OFFLINE) {
      cancelOffline();
    } else if (props.showModal === RETURN_PREVIOUS_STATUS) {
      returnPreviousStatus();
    } else if (props.showModal === MARK_SETTLED) {
      changeLotStatus(LotStatus.SETTLED);
    } else if (props.showModal === CANCEL_CONTRACT) {
      cancelContract();
    } else {
      revokeEoi();
    }
  }
  function changeLotStatus(status: LotStatus) {
    store
      .dispatch("lot/changeLotStatus", {
        id: props.lot._id,
        data: { status: status },
      })
      .then(() => {
        emits("confirm");
      });
  }
  const cancelContract = () => {
    emits("showCancelContractModal", props.lot);
  };

  function cancelOption() {
    store.dispatch("lot/cancelLotOption", props.lot._id).then(() => {
      emits("confirm");
    });
  }
  function cancelOffline() {
    store.dispatch("lot/cancelLotOffline", props.lot._id).then(() => {
      emits("confirm");
    });
  }
  const unrelease = () => {
    store
      .dispatch("lot/setStatusNotReleased", { lotIds: [props.lot._id] })
      .then(() => {
        emits("confirm");
      });
  };

  function returnPreviousStatus() {
    store.dispatch("lot/setLotPreviousStatus", props.lot._id).then(() => {
      emits("confirm");
    });
  }
  function close() {
    emits("close");
  }
  function revokeEoi() {
    store
      .dispatch("eoi/revokeEoi", {
        eoiId: props.lot.eoiId._id,
        lotId: props.lot._id,
      })
      .then(() => {
        emits("confirm");
      });
  }

const __returned__ = { emits, props, confirm, changeLotStatus, cancelContract, cancelOption, cancelOffline, unrelease, returnPreviousStatus, close, revokeEoi, LotAssignmentModal, get store() { return store }, get getFirstLastName() { return getFirstLastName }, get getLotPreviousStatus() { return getLotPreviousStatus }, get LotStatus() { return LotStatus }, get LotConfirmModalActions() { return LotConfirmModalActions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})